/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as comp from '@/components';
import * as utils from '@/utils';
export default tsx.componentFactoryOf().create({
    name: 'wizard-wrapper',
    props: {
        useLocalHeader: p(Boolean).default(false),
        getNextPageDisabledPopover: p
            .ofType()
            // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
            .default(() => () => null),
        value: p(Number).default(1),
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    data() {
        return {
            curPage: 1,
        };
    },
    computed: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        totalPages() {
            const res = utils.sumMap(Object.keys(this.$scopedSlots), item => {
                if (item.startsWith('page')) {
                    return 1;
                }
                if (item !== 'title' && item !== 'before-header' && item !== 'after-header') {
                    // eslint-disable-next-line
                    console.warn('Wrong named slot found');
                }
                return 0;
            });
            if (!IS_PRODUCTION) {
                for (let i = 1; i <= res; ++i) {
                    utils.AssertionError.assert(utils.hasAttr(this.$scopedSlots, `page-${i}`), `Could not find slot for page ${i}`);
                }
            }
            return res;
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        showPrevBtn() {
            return this.curPage > 1;
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        showNextBtn() {
            return this.curPage < this.totalPages;
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        nextPageDisabledPopover() {
            return this.getNextPageDisabledPopover(this.curPage);
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        nextBtnDisabled() {
            return this.nextPageDisabledPopover != null;
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        nextPagePopover() {
            return this.nextPageDisabledPopover ?? 'Go to next step';
        },
    },
    methods: {
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        gotoPrevPage() {
            if (this.showPrevBtn) {
                this.curPage -= 1;
            }
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        gotoNextPage() {
            if (this.showNextBtn && !this.nextBtnDisabled) {
                this.curPage += 1;
            }
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        renderHeader() {
            const children = [
                this.$scopedSlots.beforeHeader?.(),
                <b-btn class="prev-button" style={{
                        opacity: this.showPrevBtn ? 1 : 0,
                        pointerEvents: this.showPrevBtn ? 'all' : 'none',
                    }} onClick={this.gotoPrevPage} v-b-popover_top_hover={this.showPrevBtn ? 'Go to previous step' : ''}>
                    <font-awesome-icon icon="fa-solid fa-arrow-left"/>
                </b-btn>,
                <div class="flex-grow d-flex justify-content-center">
                    <h4 class="mx-3 my-0 align-self-center">
                        {this.$scopedSlots.title?.({
                        page: this.curPage,
                        totalPages: this.totalPages,
                    })}
                    </h4>
                </div>,
                <div style={{
                        opacity: this.showNextBtn ? 1 : 0,
                        pointerEvents: this.showNextBtn ? 'all' : 'none',
                    }} v-b-popover_top_hover={this.nextPagePopover}>
                    <b-btn class="next-button" disabled={this.nextBtnDisabled} onClick={this.gotoNextPage}>
                        <font-awesome-icon icon="fa-solid fa-arrow-right"/>
                    </b-btn>
                </div>,
                this.$scopedSlots.afterHeader?.(),
            ];
            if (this.useLocalHeader) {
                return <comp.LocalHeader class="d-flex mb-4">{children}</comp.LocalHeader>;
            }
            else {
                return <div class="d-flex mb-4">{children}</div>;
            }
        },
    },
    watch: {
        value: {
            immediate: true,
            // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
            handler() {
                this.curPage = this.value;
            },
        },
        // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
        curPage() {
            tsx.emitOn(this, 'onInput', this.curPage);
        },
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render() {
        return (<div class="wizard-wrapper">
                {this.renderHeader()}

                <div class="wizard-step-wrapper" style={{ margin: '0 auto', maxWidth: '45rem' }}>
                    {/* TODO: add a wizard-step class to the rendered slot? */}
                    {this.$scopedSlots[`page-${this.curPage}`]?.({
                nextPage: this.gotoNextPage,
                prevPage: this.gotoPrevPage,
            })}
                </div>
            </div>);
    },
});
